import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Container = styled.div`
  &.Wrapper{
    cursor: pointer;
  }
  &.Block{

  }
  &.FilterWrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }
  &.HiddenBlock{
    position: absolute;
    top: 60px;
    left: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    z-index: 100;
  }
  &.Margin{
    margin-bottom: 50px;
  }
  &.Width{
    min-width: 700px;
  }
`;

export const StyledSpan = styled.span`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 135%;
  color: #000000;
  margin-right: 4px;
  transition: ease-in-out 0.2s;
  cursor: pointer;
`;

export const VerticalDivider = styled.span`
  border-right: 1px solid rgba(0, 0, 0, 0.3);
  height: 28px;
  align-self: flex-start;
`